import {get} from '../apiService';

export const getStatisticsHomePage=()=>{
  return get(`/statistics/admin-home-page`)
}